export default __webpack_public_path__ + "static/media/forgot-password-graphic@2x.2145c426.png";